import { useState } from 'react';
import { sendFeedback } from '../lib/feedback';
import { track } from '../analytics';

/**
 * Tell Kraben something.
 *
 * Closed it is one quiet link, because the app is not asking to be reviewed —
 * it is Day 1 of somebody's own thing and a survey in the middle of that is an
 * interruption. Open it is one field and one button.
 *
 * It lives wherever a person is most likely to have just felt something: Home,
 * and the card they have this moment finished. `where` says which, so a pile of
 * these can be read by place and not only by time.
 *
 * A failed send keeps the words on screen and offers the button again. The one
 * unforgivable thing this component could do is swallow what somebody took the
 * trouble to type.
 */
export function Say({ where, day, challengeId }: { where: string; day?: number; challengeId?: string }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'failed'>('idle');

  if (state === 'sent') return <p className="hint" style={{ textAlign: 'center' }}>Kraben has it. Thank you.</p>;

  if (!open) {
    return (
      <div className="row" style={{ justifyContent: 'center' }}>
        <button className="link" onClick={() => { setOpen(true); track('say_opened', { where }); }}>Tell Kraben what you think</button>
      </div>
    );
  }

  const send = async () => {
    if (!text.trim()) return;
    setState('sending');
    try {
      await sendFeedback(text, where, { day, challengeId });
      track('say_sent', { where, length: text.trim().length });
      setState('sent');
    } catch (err) {
      console.warn('[kindling] feedback failed', err);
      setState('failed');
    }
  };

  return (
    <div className="stack">
      <span className="label">Tell Kraben</span>
      <textarea
        className="input"
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Anything. What was confusing, what was good, what you wanted next."
        autoFocus
      />
      <div className="row between">
        <button className="link" onClick={() => setOpen(false)}>Not now</button>
        <button className="btn small" onClick={send} disabled={!text.trim() || state === 'sending'}>
          {state === 'sending' ? 'Sending…' : 'Send'}
        </button>
      </div>
      {state === 'failed' && <p className="hint">That did not send. Your words are still here — try again.</p>}
    </div>
  );
}
